<h1 id="step-heading" class="step-heading">
  <%= I18n.verify_id.heading %>
</h1>
<div class="step-form">
  <% if (verify_id_question_generation_error) { %>
    <div class="appointment-booking-wizard-callout borderless" data-testid="<%= testIds.booking.verifyIdError %>">
      <div class="message message-warning">
        <p>
          <%= I18n.verify_id.question_generation_error[id_verification_strategy] %>
        </p>
      </div>
    </div>
  <% } else { %>
    <div class="fieldset" data-testid="<%= testIds.booking.verifyId %>">
      <% jQuery.each(verify_id_questions, function(questionIndex, question) { %>
      <div class="field">
        <label class="field-label"><%= question.name %></label>
        <div class="field-input select">
          <select data-appointment-booking-wizard-behaviour="field-input" name="verify_id_answers[<%= questionIndex %>][index]" required>
            <option value=""><%= I18n.verify_id.prompts.answer %></option>
            <% jQuery.each(question.answers, function(answerIndex, answer) { %>
              <% var answerId = answerIndex + 1 %>
              <option value="<%= answerId %>" <% if (verify_id_answer_indices[questionIndex] == answerId) { %>selected<% } %>><%= answer %></option>
            <% }) %>
          </select>
        </div>
        <span class="validation-error"><%= I18n.errors.required_field %></span>
      </div>
      <% }) %>
    </div>
  <% } %>
</div>
